import { Scene as BaseScene } from 'phaser';
import { Request } from './request';
import { Relay } from './relay';
import { Dropper as SlotsDropper } from '@sl/base/logic/slots/dropper';
import { RhombusDropper as SlotsRhombusDropper } from '@sl/base/logic/slots/rhombus_dropper';
import { Default as SlotsDefault } from '@sl/base/logic/slots/default';
import store from '@sl/base/store';

export class Scene extends BaseScene {
    constructor() {
        super();
        this.orientation = 'landscape';
        this.device = 'desktop';
        this.gameHeight = 768;
        this.yCenterPoint = 384;
        this.request = new Request(this);
        this.relay = new Relay(this);

        switch(Config.settings.spin_type) {
            case 'dropper':
                this.slots = new SlotsDropper(this);
                break;
            case 'rhombus_dropper':
                this.slots = new SlotsRhombusDropper(this);
                break;
            default:
                this.slots = new SlotsDefault(this);
        }
    }

    init() {
        this.game.sound.pauseOnBlur = false;
        
        if (!this.sys.game.device.os.desktop) {
            this.checkIfOrientationChanged();
            this.device = 'mobile';
            this.toggleMute(false);
            store.commit('toggleMute');
            document.getElementById("slots-container").classList.add('mobile');
        } else if (this.sys.game.device.browser.safari) {
            this.toggleMute(false);
            store.commit('toggleMute');
        }

        store.commit('setDevice', this.device);

        this.themeSound = this.sound.add('theme', {"loop":true});
        this.themeSound.play();

        this.scale.on('resize', this.resize, this);

        if(this.game.input.touch) {
            this.game.input.touch.capture = false;
        }

        document.getElementById('slots-container').classList.add('loaded'); 
        document.getElementById('slots-container').classList.remove('loading'); 
        
        var loaderContainer = document.getElementsByClassName('loader-container')[0]; 

        if(loaderContainer) {
            loaderContainer.remove();
        }
    }

    resize() {
        this.checkIfOrientationChanged();
    }

    update() {
        if(this.slots) {
            this.slots.update();
        }
    }

    letInitialize(initCallback) {
        initCallback();
        if (Config.waiting_ticket_id) {
            this.request.loadWaitingTicket(Config.waiting_ticket_id, Config.waiting_ticket_unfinished);
        }
    }

    beforePurchase() {
        console.log('beforePurchase')
    }

    afterPurchase() {
        console.log('afterPurchase')
    }

    afterStep() {
        console.log('afterStep')
    }

    toggleMute(mute) {
        this.sound.setMute(mute);
    }

    clickEvent(clickEvent) {
        if(typeof this.customClickEvent === 'function') {
            this.customClickEvent(clickEvent);
        }
    }

    canvasReady() {
        store.commit('canvasReady');
    }
    
    currentDeviceOrientationIsPortrait() {
        return Config.windowHeight > Config.windowWidth;
    }

    checkIfOrientationChanged() {
        const currentOrientation = this.currentDeviceOrientationIsPortrait() ? 'portrait' : 'landscape';

        if(!this.sys.game.device.os.desktop && currentOrientation !== this.orientation) {
            this.orientation = currentOrientation;
            
            if(this.orientation === 'portrait') { 
               this.scale.setGameSize(Config.resolutionX_portrait, Config.resolutionY_portrait);
               this.scale.displaySize.resize(Config.resolutionX_portrait, Config.resolutionY_portrait);
               
            } else {
                this.scale.setGameSize(Config.resolutionX, Config.resolutionY);
                this.scale.displaySize.resize(Config.resolutionX, Config.resolutionY);
            }

            this.scale.refresh();

            this.baseGamePositioner();
        }
    }

    baseGamePositioner() {
        if(!this.spritesReady) {
            return;
        }

        this.winningsContainer.x = this.cameras.main.centerX;
        this.winningsContainer.y = 0;
        this.positionerContainer.x = this.cameras.main.centerX;
        this.positionerContainer.y = 0;
        this.slots.frameContainer.x = this.cameras.main.centerX;
        this.slots.frameContainer.y = 0;
        this.slots.symbolsAndPaylinesContainer.x = this.cameras.main.centerX;
        this.slots.symbolsAndPaylinesContainer.y = 0;
        this.slots.reelsContainer.x = this.cameras.main.centerX;
        this.slots.reelsContainer.y = 0;
        this.slots.createReelsMask();
        this.bonus.bonusContainer.x = this.cameras.main.centerX;
        this.bonus.bonusContainer.y = 0;

        if(typeof this.gamePositioner === 'function') {
            this.gamePositioner();
        }
        
        this.slots.frameContainerFront.setScale(this.slots.frameContainer.scale);
        this.slots.frameContainerFront.x = this.slots.frameContainer.x;
        this.slots.frameContainerFront.y = this.slots.frameContainer.y;
        
        this.slots.addBackgrounds();
    }

    orientationIsSetToPortrait() {
        return this.orientation === 'portrait';
    }
}